import React, {useEffect, useRef} from "react";
import {BlockContainer, InnerBlockContainer, ContentContainer} from "BaseComponents/Wrappers";
import {H2} from "BaseComponents/Text";
import {CountingNumberItem} from "./CountingNumbersItem";

export const CountingNumbersBlock = ({CountingNumberItems, Heading}) => {


    return (
        <BlockContainer>

            <InnerBlockContainer>
                {!!Heading.length && <H2 textAlign="center">{Heading}</H2>}
                <ContentContainer justifyContent="center" flexWrap="wrap" margin="0 -15px">
                    {CountingNumberItems.map((countingNumberItem, key) => {
                        return <CountingNumberItem key={`cn-item-${key}`} {...countingNumberItem} />;
                    })}
                </ContentContainer>
            </InnerBlockContainer>
        </BlockContainer>
    );
};
